import { ActionTypes } from "./game.types";
import { IDispatch } from "redux/store";
import axios from "services/axios.service";
import { endpoints } from "config/endpoints";
import { track } from "utils";
import { MyliEventType } from "utils/types/event";
import type { AxiosError } from "axios";
import {
  RewardValidationFailure,
  RewardValidationResult,
} from "./game.interface";

export const setPlay =
  (entityId: string, requestId: string) => async (dispatch: IDispatch) => {
    try {
      const { data } = await axios.api.post(
        endpoints.api.game.play,
        {
          cid: entityId,
          rid: requestId,
        },
        { withCredentials: true }
      );

      dispatch({
        type: ActionTypes.SET_GAME_PLAY,
        payload: data,
      });
    } catch (error) {
      console.error("setPlay API error:", error);
      throw error;
    }
  };

export const setCanPlayAgain = (entityId: string) => async (dispatch: any) => {
  try {
    const { data } = await axios.api.get(endpoints.api.game.canPlayAgin, {
      params: {
        cid: entityId,
      },
    });
    dispatch({
      type: ActionTypes.SET_GAME_CAN_PLAY_AGAIN,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("setCanPlayAgain - Session is not ready", error);
    return null;
  }
};

export const resetGame =
  (entityId: string | undefined) => (dispatch: IDispatch) => {
    track(MyliEventType.GAME_RESTART, {
      campaignId: entityId,
    });
    dispatch({
      type: ActionTypes.RESET_GAME,
    });
  };

export const setRewardValidation =
  (cid: string, rid: string) => async (dispatch: IDispatch) => {
    try {
      const { data } = await axios.api.post(endpoints.api.reward.validate, {
        cid,
        rid,
      });

      dispatch({
        type: ActionTypes.SET_GAME_REWARD_VALIDATED,
        payload: data,
      });

      return { success: true } as RewardValidationResult;
    } catch (error) {
      const { response } = error as AxiosError<{
        error?: string;
      }>;

      if (response?.data?.error === "A_V") {
        return {
          success: false,
          error: RewardValidationFailure.ALREADY_CLAIMED,
        } as RewardValidationResult;
      }

      if (response?.data?.error === "R_E") {
        return {
          success: false,
          error: RewardValidationFailure.EXPIRED,
        } as RewardValidationResult;
      }

      if (response?.status === 400) {
        return {
          success: false,
          error: RewardValidationFailure.NOT_FOUND,
        } as RewardValidationResult;
      }

      console.error("setRewardValidation API error:", error);
      return {
        success: false,
        error: RewardValidationFailure.TEMPORARY,
      } as RewardValidationResult;
    }
  };

export const setRewardInfo =
  (rid: string, s: string) => async (dispatch: IDispatch) => {
    try {
      const { data } = await axios.api.get(endpoints.api.reward.info, {
        params: {
          rid,
          s,
        },
      });

      dispatch({
        type: ActionTypes.SET_GAME_REWARD_INFO,
        payload: { ...data, isFetched: true },
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.SET_GAME_REWARD_INFO_ERROR,
        payload: { isFetched: true, hasError: true },
      });
    }
  };
